<template>
  <div
    class="d-flex align-items-center justify-content-center min-vh-100"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <CContainer fluid>
      <CToaster :autohide="3000">
        <template v-for="info in infoList">
          <CToast
            :key="info.id"
            :show="true"
            :header="info.header"
            :color="info.color"
          >
            {{ info.message }}
          </CToast>
        </template>
      </CToaster>
      <CRow class="justify-content-center">
        <CCol md="6" lg="5">
          <CCard class="mx-4 mb-0 text-center">
            <CCardBody class="p-5">
              <!-- Icon or Image for Visual Appeal -->
              <CIcon
                name="cil-envelope-closed"
                size="4xl"
                class="mb-4 text-marketing-primary"
              />

              <!-- Main Heading and Instructions -->
              <h2 class="mb-3 text-marketing-primary">Forgot your password?</h2>
              <p class="text-muted mb-4">
                Enter your email address below, and we'll send you a link to
                reset your password.
              </p>

              <!-- Email Input Field -->
              <CInput
                label="Email *"
                type="email"
                autocomplete="email"
                prepend="@"
                v-model="email"
                class="mb-3 border-marketing-primary text-left"
                :disabled="loading"
                :is-valid="emailError ? false : null"
                :invalid-feedback="emailError"
              />

              <!-- Send Reset Link Button -->
              <CButton
                class="mb-3 btn-marketing-accent"
                :disabled="loading"
                @click="sendResetLink"
              >
                <CSpinner v-if="loading" size="sm" /> Send reset link
              </CButton>

              <!-- Link to Go Back to Login Page -->
              <p class="mt-4">
                <router-link
                  to="/login"
                  class="text-marketing-accent font-weight-bold"
                  >Remembered your password? Log in</router-link
                >
              </p>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
  
  <script>
export default {
  name: "ForgotPassword",
  data: () => ({
    email: "", // User's email input
    infoList: [],
    emailError: "",
    loading: false, // Loading state
  }),
  methods: {
    sendResetLink() {
      // Validate email input
      if (!this.email) {
        this.emailError = "Enter the email you signed up with";
        return;
      }
      this.emailError = "";

      this.loading = true;
      var resendDto = {
        email: this.email,
      };

      auth
        .sendForgotPassword(resendDto)
        .then((response) => {
          this.loading = false;
          this.toast("Info", "Reset link sent. Check your email", "info");
        })
        .catch(({ data }) => {
          this.loading = false;
          console.error(data);
          this.toast(
            "Error",
            "Couldn't send the reset link. " + helper.getErrorMessage(data),
            "danger"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    navigateToLogin() {
      this.$router.push({ path: "/login" });
    },
    toast(header, message, color) {
      this.infoList.push({
        id: Date.now() + Math.random(),
        header: header,
        message: message,
        color: color,
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.c-icon {
  margin-bottom: 1rem;
}
</style>
  